module.exports = __webpack_public_path__ + "static/media/sxs_active.193efdd8.svg";